import { useQuery } from '@tanstack/react-query';

import { fetchOrganizationComments } from '@/api/v4/organization-comments.api';
import { QueryKey } from '@/config/query-client';
import { projectIdState } from '@/features/projects/project.state';
import { teamIdState } from '@/features/teams/team.state';

import { companyIdState } from '../../company.state';
import { useAtomValue } from 'jotai';

export const useCompanyComments = () => {
  const companyId = useAtomValue(companyIdState);
  const projectId = useAtomValue(projectIdState);
  const teamId = useAtomValue(teamIdState);

  const fetchCompanyComments = async () => {
    if (!companyId) return [];

    return fetchOrganizationComments({ organizationId: companyId });
  };

  return useQuery({
    queryKey: [QueryKey.CompanyComments, companyId, projectId, teamId],
    queryFn: fetchCompanyComments,
    enabled: !!companyId,
    staleTime: 1000 * 60 * 5,
  });
};
